/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_link_minecraft_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft account successfully linked!`)
};

const zh_hans1_link_minecraft_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 账号绑定成功！`)
};

const zh_hant1_link_minecraft_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 帳號綁定成功！`)
};

const fr_link_minecraft_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte Minecraft lié avec succès !`)
};

const de_link_minecraft_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft-Konto erfolgreich verknüpft!`)
};

const ja_link_minecraft_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraftアカウントの連携が完了しました！`)
};

const ko_link_minecraft_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 계정이 성공적으로 연동되었습니다!`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const link_minecraft_success = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.link_minecraft_success(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("link_minecraft_success", locale)
	if (locale === "en") return en_link_minecraft_success(inputs)
	if (locale === "zh-Hans") return zh_hans1_link_minecraft_success(inputs)
	if (locale === "zh-Hant") return zh_hant1_link_minecraft_success(inputs)
	if (locale === "fr") return fr_link_minecraft_success(inputs)
	if (locale === "de") return de_link_minecraft_success(inputs)
	if (locale === "ja") return ja_link_minecraft_success(inputs)
	return ko_link_minecraft_success(inputs)
};